import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import styles from './Leadership.module.css';
import { trustees } from '../../utils/data/trustees';
import { executive } from '../../utils/data/executive';
import { editorialBoard } from '../../utils/data/editorialBoard';

const Leadership = () => {
  return (
    <div className={styles.leadership}>
      {/* Header */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>Our Leadership</h1>
        <p className={styles.pageSubtitle}>
          Meet the dedicated professionals guiding IMDF
        </p>
      </section>

      {/* Trustees */}
      {/* <section className={styles.section}>
        <SectionTitle
          title="Board of Trustees"
          subtitle="Guardians of the Foundation"
        />
        <p className={styles.sectionIntro}>
          The Trustees hold the assets of the Foundation and ensure its long-term integrity.
        </p>

        <div className={styles.trusteesGrid}>
          {trustees.map((member) => (
            <div key={member.id} className={styles.trusteeCard}>
              <div className={styles.trusteeImageWrapper}>
                <img
                  src={member.image}
                  alt={member.name}
                  className={styles.trusteeImage}
                />
              </div>
              <div className={styles.trusteeContent}>
                <h3 className={styles.trusteeName}>{member.name}</h3>
                <p className={styles.trusteeRole}>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Executive Committee */}
      <section className={styles.section}>
        <SectionTitle
          title="Executive Committee"
          subtitle="Managing the Foundation"
        />
        <p className={styles.sectionIntro}>
          The Executive Committee oversees the day-to-day operations.
        </p>

        <div className={styles.trusteesGrid}>
          {executive.map((member) => (
            <div key={member.id} className={styles.trusteeCard}>
              <div className={styles.trusteeImageWrapper}>
                <img
                  src={member.image}
                  alt={member.name}
                  className={styles.trusteeImage}
                />
              </div>
              <div className={styles.trusteeContent}>
                <h3 className={styles.trusteeName}>{member.name}</h3>
                <p className={styles.trusteeRole}>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Editorial Board */}
      {/* <section className={styles.section}>
        <SectionTitle
          title="Editorial Board"
          subtitle="Publishing the Journal"
        />
        <p className={styles.sectionIntro}>
          Responsible for the Foundation’s scholarly publications.
        </p>

        <div className={styles.trusteesGrid}>
          {editorialBoard.map((member) => (
            <div key={member.id} className={styles.trusteeCard}>
              <div className={styles.trusteeImageWrapper}>
                <img
                  src={member.image}
                  alt={member.name}
                  className={styles.trusteeImage}
                />
              </div>
              <div className={styles.trusteeContent}>
                <h3 className={styles.trusteeName}>{member.name}</h3>
                <p className={styles.trusteeRole}>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}
    </div>
  );
};

export default Leadership;